export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-76x76-849410c9c16e4772600441130c5cddce.png";